import { RecoveryCalculator as Recovery } from './Recovery/RecoveryCalculator'
import { ResultsCalculator as Results } from './Results/ResultsCalculator'
import { RevenueCalculator as Revenue } from './Revenue/RevenueCalculator'

export default {
  Recovery,
  Results,
  Revenue
}
